import { Badge, Box, Paper, Stack, Typography } from "@mui/material";
import { monthMatrix, toISODate, sameDay, WEEKDAY_LABELS } from "../../utils/calendar";
import { useLanguage } from "../../i18n/LanguageContext";
import { COLORS } from "../../theme";

export default function CalendarMonthView({ anchorDate, bookings, onSelectDay, onSelectBooking }) {
  const { lang } = useLanguage();
  const weeks = monthMatrix(anchorDate);
  const today = new Date();

  const bookingsFor = (day) => bookings.filter((b) => b.date === toISODate(day));

  return (
    <Paper variant="outlined">
      <Box sx={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)" }}>
        {WEEKDAY_LABELS[lang].map((d) => (
          <Box key={d} sx={{ p: 1, textAlign: "center", fontSize: 11, color: "text.secondary", fontWeight: 600, borderBottom: `1px solid ${COLORS.line}` }}>
            {d}
          </Box>
        ))}
        {weeks.flat().map((day, i) => {
          const inMonth = day.getMonth() === anchorDate.getMonth();
          const dayBookings = bookingsFor(day);
          const isToday = sameDay(day, today);
          return (
            <Box
              key={i}
              onClick={() => onSelectDay(day)}
              sx={{
                minHeight: 76,
                p: 1,
                borderRight: `1px solid ${COLORS.line}`,
                borderBottom: `1px solid ${COLORS.line}`,
                cursor: "pointer",
                bgcolor: inMonth ? "background.paper" : "#F4F5EF",
                opacity: inMonth ? 1 : 0.55,
                "&:hover": { bgcolor: COLORS.brassSoft },
              }}
            >
              <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Box
                  sx={{
                    width: 22, height: 22, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 12, fontWeight: isToday ? 700 : 400,
                    bgcolor: isToday ? COLORS.ink : "transparent", color: isToday ? "#fff" : "text.primary",
                  }}
                >
                  {day.getDate()}
                </Box>
                {dayBookings.length > 1 && (
                  <Badge badgeContent={dayBookings.length} color="primary" sx={{ "& .MuiBadge-badge": { fontSize: 9, height: 15, minWidth: 15 } }} />
                )}
              </Stack>
              <Stack spacing={0.3} sx={{ mt: 0.5 }}>
                {dayBookings.slice(0, 2).map((b) => (
                  <Typography
                    key={b._id}
                    variant="caption"
                    noWrap
                    onClick={(e) => { e.stopPropagation(); onSelectBooking(b); }}
                    sx={{ display: "block", bgcolor: COLORS.greenSoft, color: COLORS.green, borderRadius: 0.5, px: 0.5, fontSize: 10, cursor: "pointer", "&:hover": { outline: `1px solid ${COLORS.green}` } }}
                  >
                    {b.fullDay ? b.occupantId?.name : `${String(b.startHour).padStart(2, "0")}:00 ${b.occupantId?.name}`}
                  </Typography>
                ))}
                {dayBookings.length > 2 && (
                  <Typography variant="caption" color="text.secondary" sx={{ fontSize: 10 }}>
                    +{dayBookings.length - 2}
                  </Typography>
                )}
              </Stack>
            </Box>
          );
        })}
      </Box>
    </Paper>
  );
}
